const RoutesUserLoggedOut = [
  {
    path: "/",
    lazy: async () => {
      const { default: BemVindo } =
        await import("@/pages/UserLoggedOut/BemVindo");
      return { element: <BemVindo /> };
    },
  },
  {
    path: "/auth/google/callback",
    lazy: async () => {
      const { default: GoogleCallback } =
        await import("@/pages/UserLoggedOut/Auth/google-callback");
      return { element: <GoogleCallback /> };
    },
  },
  {
    path: "/login",
    lazy: async () => {
      const { default: LayoutAuth } =
        await import("@/pages/UserLoggedOut/Auth/layout");
      return { element: <LayoutAuth /> };
    },
    children: [
      {
        path: "",
        lazy: async () => {
          const { default: Login } =
            await import("@/pages/UserLoggedOut/Auth/login");
          return { element: <Login /> };
        },
      },
      {
        path: "esqueci-senha",
        lazy: async () => {
          const { default: EsqueciSenha } =
            await import("@/pages/UserLoggedOut/Auth/esqueci-senha");
          return { element: <EsqueciSenha /> };
        },
      },
      {
        path: "nova-senha",
        lazy: async () => {
          const { default: NovaSenha } =
            await import("@/pages/UserLoggedOut/Auth/nova-senha");
          return { element: <NovaSenha /> };
        },
      },
      {
        path: "2fa",
        lazy: async () => {
          const { default: Verificar2FA } =
            await import("@/pages/UserLoggedOut/Auth/verificar-2fa");
          return { element: <Verificar2FA /> };
        },
      },
    ],
  },
  {
    path: "continuar-cadastro",
    lazy: async () => {
      const { default: ContinuarCadastro } =
        await import("@/pages/UserLoggedOut/Auth/continuar-cadastro");
      return { element: <ContinuarCadastro /> };
    },
  },
  {
    path: "continuar-cadastro-adlink",
    lazy: async () => {
      const { default: ContinuarCadastroAdLink } =
        await import("@/pages/UserLoggedOut/Auth/continuar-cadastro-adlink");
      return { element: <ContinuarCadastroAdLink /> };
    },
  },
  {
    path: "cadastro-adlink",
    lazy: async () => {
      const { default: CadastroAdLink } =
        await import("@/pages/UserLoggedOut/Auth/cadastro-adlink");
      return { element: <CadastroAdLink /> };
    },
  },
  // {
  //   path: "empresas/vagas",
  //   lazy: async () => {
  //     const { default: EmpresasVagas } =
  //       await import("@/pages/UserLoggedOut/EmpresasVagas");
  //     return { element: <EmpresasVagas /> };
  //   },
  // },
  {
    path: "empresas/cadastro",
    lazy: async () => {
      const { default: EmpresaCadastro } =
        await import("@/pages/UserLoggedOut/EmpresaCadastro");
      return { element: <EmpresaCadastro /> };
    },
  },
  // {
  //   path: "candidatos/vagas",
  //   lazy: async () => {
  //     const { default: CandidatosVagas } =
  //       await import("@/pages/UserLoggedOut/CandidatosVagas");
  //     return { element: <CandidatosVagas /> };
  //   },
  // },
  {
    path: "/ajuda",
    lazy: async () => {
      const { default: PerguntasFrequentes } =
        await import("@/pages/UserLoggedOut/PerguntasFrequentes");
      return { element: <PerguntasFrequentes /> };
    },
  },
  {
    path: "/dashboard/:hash/:pi",
    lazy: async () => {
      const { default: DashboardNoLogin } =
        await import("@/pages/UserLoggedOut/DashboardNoLogin");
      return { element: <DashboardNoLogin /> };
    },
  },
  {
    path: "/vaga/:slug",
    lazy: async () => {
      const { default: VagaPublica } =
        await import("@/pages/Recrutamento/CompartilhamentoVaga/VagaPublica");
      return { element: <VagaPublica /> };
    },
  },
  {
    path: "/empresa/:slug",
    lazy: async () => {
      const { default: CompanyProfilePage } =
        await import("@/pages/AdLink/CompanyProfile/CompanyProfile");
      return { element: <CompanyProfilePage /> };
    },
  },
  {
    path: "/talentos/:slug",
    lazy: async () => {
      const { default: TalentoPublico } =
        await import("@/pages/Public/TalentoPublico/TalentoPublico");
      return { element: <TalentoPublico /> };
    },
  },
  {
    path: "/recomendar/:token",
    lazy: async () => {
      const { default: RecomendacaoPublica } =
        await import("@/pages/Public/RecomendacaoPublica/RecomendacaoPublica");
      return { element: <RecomendacaoPublica /> };
    },
  },
  {
    path: "/profile-veiculo/:slug",
    lazy: async () => {
      const { VehicleProfilePublicRoute } =
        await import("@/pages/UserGoOn/Representado/VehicleProfile");
      return { element: <VehicleProfilePublicRoute /> };
    },
  },
  {
    path: "/formularios/prospeccao/:publicKey",
    lazy: async () => {
      const { default: PublicInboundFormPage } =
        await import("@/pages/UserGoOn/Prospeccoes/Inbound/PublicInboundFormPage");
      return { element: <PublicInboundFormPage /> };
    },
  },
  {
    path: "/politica-de-privacidade",
    lazy: async () => {
      const { default: PoliticaPrivacidade } =
        await import("@/pages/UserLoggedOut/PoliticaPrivacidade");
      return { element: <PoliticaPrivacidade /> };
    },
  },
  {
    path: "/termos-de-uso",
    lazy: async () => {
      const { default: TermosUso } =
        await import("@/pages/UserLoggedOut/TermosUso");
      return { element: <TermosUso /> };
    },
  },
];

export default RoutesUserLoggedOut;
